import Vue from 'vue';
import { callMathRender, observe } from './mathJaxUtils';
import { highlightEventHub } from 'library-@/highlight/core';

/*
Usage:
<div v-math> </div>

狂野模式：
<div v-math.brutal> </div>

*/
Vue.directive('math', {
    inserted: function (el, binding) {
        el._mathBrutalMode = binding.modifiers.brutal;
        el._callSelfMathRender = function () {
            callMathRender(el);
        };
        if (el._mathBrutalMode) {
            el._mathBrutalMode = observe(el, function () {
                el._callSelfMathRender();
            });
        }

        // 这是对的，不要用else链接起来
        if (!el._mathBrutalMode) {
            el._callSelfMathRender();

            highlightEventHub.on('completed', el._callSelfMathRender);
        }
    },
    componentUpdated: function (el) {
        if (!el._mathBrutalMode) {
            callMathRender(el);
        }
    },
    unbind: function (el) {
        observe(el, false);
        highlightEventHub.removeListener('completed', el._callSelfMathRender);
    }
});
